const MapEvents = require('od-modules/helpers/map/events');
const ControlButtonGroup = require('od-modules/helpers/map/button/control_btn_group');
const HotelInfoWindow = require('od-modules/helpers/map/info/info_window');
const HotelInfoBox = require('od-modules/helpers/map/info/info_box');
const mapClusterTemplate = Odigeo._.template(require('od-modules/helpers/map/templates/map_cluster.html'), Odigeo.Utils.getTmplSettings());
const MARKER_CLUSTER_HOOK = 'od_custom_marker';

function getClusterConfig(options) {
    return Object.assign({
        gridSize: 60,
        minimumClusterSize: 2,
    }, options.clusterCustomConfig);
}

module.exports = function(map, libMap, options) {
    const mapEvents = MapEvents.getListeners(libMap);
    let cluster;
    let buttonGroup;
    let hotelInfo;

    return {

        createBtnGroup: function(cfg) {
            if (options.absConfig.hasToggleMarkerButtons) {
                buttonGroup = new ControlButtonGroup(map, libMap);
                mapEvents.listenTo(buttonGroup, {
                    'launch': cfg.btnGroupCbk,
                });
            }
        },

        cleanMapCluster: function() {
            if (cluster instanceof libMap.MarkerCluster) {
                cluster.clearMarkers();
            }
        },

        createMapCluster: function(markers) {
            cluster = new libMap.MarkerCluster(map, markers, getClusterConfig(options));
        },

        setClustersLabeled: function() {
            const MARKER_CLUSTER_CSS = 'od-custom-marker od-custom-marker-tooltip odf-space-inner-s odf-tooltip odf-tooltip-plain open';
            const baseCalculator = cluster.getCalculator();
            const clusterTemplate = (text) => mapClusterTemplate({
                clusterNumber: text, clusterLabel: Odigeo.UIElements.translations.dynpackProduct.mapClusterLabel,
            });
            const addLabel = ({text, index}) => ({text: clusterTemplate(text), index});
            const customCalculator = (markers, numStyles) => addLabel(baseCalculator(markers, numStyles));
            cluster.setCssClass(`${MARKER_CLUSTER_HOOK} ${MARKER_CLUSTER_CSS}`);
            cluster.setCalculator(customCalculator);
        },

        setClustersRegularStyle: function() {
            const MARKER_CLUSTER_CSS = 'od-custom-marker od-custom-marker-cluster';
            cluster.setCssClass(`${MARKER_CLUSTER_HOOK} ${MARKER_CLUSTER_CSS}`);
        },

        excludeMarkerFromCluster: function(marker) {
            if (marker instanceof libMap.OverlayView) {
                cluster.removeMarker(marker, true);
                cluster.repaint();
                marker.setMap(map);
            }
        },

        getHotelInfo: function() {
            return hotelInfo;
        },

        getMapCluster: function() {
            return cluster;
        },

        createHotelInfo: function() {
            if (options.absConfig.hasBubbleTemplate) {
                hotelInfo = new HotelInfoWindow(map, libMap, options);
            } else if (options.absConfig.hasTooltipTemplate) {
                hotelInfo = new HotelInfoBox(map, libMap, options);
            }
        },

        isInfoWindowOpen: function() {
            return hotelInfo.getInfoWindow().getMap() instanceof libMap.Map;
        },

        getClusterHook: function() {
            return MARKER_CLUSTER_HOOK;
        },
    };
};
